import StringUtil from "./StringUtil";
import TailwindColorsAssets from '../../assets/tailwind-colors'

export default class ColorUtil {

    static colorMap = {};

    static loadBootstrapColors(colorList) {
        let colors = Object.keys(colorList)

        for(let i = 0; i < colors.length; i++ ) {
            let color = colors[i]
            let colorObject = colorList
        }
    }

    static standardColorNames() {
        return ['AliceBlue','AntiqueWhite','Aqua','Aquamarine','Azure','Beige','Bisque','Black','BlanchedAlmond','Blue','BlueViolet','Brown','BurlyWood','CadetBlue','Chartreuse','Chocolate','Coral','CornflowerBlue','Cornsilk','Crimson','Cyan','DarkBlue','DarkCyan','DarkGoldenRod','DarkGray','DarkGrey','DarkGreen','DarkKhaki','DarkMagenta','DarkOliveGreen','DarkOrange','DarkOrchid','DarkRed','DarkSalmon','DarkSeaGreen','DarkSlateBlue','DarkSlateGray','DarkSlateGrey','DarkTurquoise','DarkViolet','DeepPink','DeepSkyBlue','DimGray','DimGrey','DodgerBlue','FireBrick','FloralWhite','ForestGreen','Fuchsia','Gainsboro','GhostWhite','Gold','GoldenRod','Gray','Grey','Green','GreenYellow','HoneyDew','HotPink','IndianRed','Indigo','Ivory','Khaki','Lavender','LavenderBlush','LawnGreen','LemonChiffon','LightBlue','LightCoral','LightCyan','LightGoldenRodYellow','LightGray','LightGrey','LightGreen','LightPink','LightSalmon','LightSeaGreen','LightSkyBlue','LightSlateGray','LightSlateGrey','LightSteelBlue','LightYellow','Lime','LimeGreen','Linen','Magenta','Maroon','MediumAquaMarine','MediumBlue','MediumOrchid','MediumPurple','MediumSeaGreen','MediumSlateBlue','MediumSpringGreen','MediumTurquoise','MediumVioletRed','MidnightBlue','MintCream','MistyRose','Moccasin','NavajoWhite','Navy','OldLace','Olive','OliveDrab','Orange','OrangeRed','Orchid','PaleGoldenRod','PaleGreen','PaleTurquoise','PaleVioletRed','PapayaWhip','PeachPuff','Peru','Pink','Plum','PowderBlue','Purple','RebeccaPurple','Red','RosyBrown','RoyalBlue','SaddleBrown','Salmon','SandyBrown','SeaGreen','SeaShell','Sienna','Silver','SkyBlue','SlateBlue','SlateGray','SlateGrey','Snow','SpringGreen','SteelBlue','Tan','Teal','Thistle','Tomato','Turquoise','Violet','Wheat','White','WhiteSmoke','Yellow','YellowGreen']
    }

    static standardColorNameHexValues() {
        return ['f0f8ff','faebd7','00ffff','7fffd4','f0ffff','f5f5dc','ffe4c4','000000','ffebcd','0000ff','8a2be2','a52a2a','deb887','5f9ea0','7fff00','d2691e','ff7f50','6495ed','fff8dc','dc143c','00ffff','00008b','008b8b','b8860b','a9a9a9','a9a9a9','006400','bdb76b','8b008b','556b2f','ff8c00','9932cc','8b0000','e9967a','8fbc8f','483d8b','2f4f4f','2f4f4f','00ced1','9400d3','ff1493','00bfff','696969','696969','1e90ff','b22222','fffaf0','228b22','ff00ff','dcdcdc','f8f8ff','ffd700','daa520','808080','808080','008000','adff2f','f0fff0','ff69b4','cd5c5c','4b0082','fffff0','f0e68c','e6e6fa','fff0f5','7cfc00','fffacd','add8e6','f08080','e0ffff','fafad2','d3d3d3','d3d3d3','90ee90','ffb6c1','ffa07a','20b2aa','87cefa','778899','778899','b0c4de','ffffe0','00ff00','32cd32','faf0e6','ff00ff','800000','66cdaa','0000cd','ba55d3','9370db','3cb371','7b68ee','00fa9a','48d1cc','c71585','191970','f5fffa','ffe4e1','ffe4b5','ffdead','000080','fdf5e6','808000','6b8e23','ffa500','ff4500','da70d6','eee8aa','98fb98','afeeee','db7093','ffefd5','ffdab9','cd853f','ffc0cb','dda0dd','b0e0e6','800080','663399','ff0000','bc8f8f','4169e1','8b4513','fa8072','f4a460','2e8b57','fff5ee','a0522d','c0c0c0','87ceeb','6a5acd','708090','708090','fffafa','00ff7f','4682b4','d2b48c','008080','d8bfd8','ff6347','40e0d0','ee82ee','f5deb3','ffffff','f5f5f5','ffff00','9acd32']
    }

    static getHexValue(colorName) {
        let colors = ColorUtil.standardColorNames()

        for(let i = 0; i < colors.length; i++ ) {

            if(colorName === colors[i]) {
                return ColorUtil.standardColorNameHexValues()[i]
            }
        }
    }

    static getColorObject(colorValue) {
        return ColorUtil.colorMap[colorValue]
    }

    static getColorName(colorValue) {
        let colorName = null

        if(colorValue === '#FFFFFF') {
            colorName = 'white'
        }
        else if(colorValue === '#000000') {
            colorName = 'black'
        }
        else {
            colorName = ColorUtil.colorMap[colorValue].color
        }

        return StringUtil.capitalize(colorName)
    }

    // convert a decimal value to hex
    d2h(d) {
        return d.toString(16);
    }

    // convert a hex value to decimal
    h2d(h) {
        return parseInt(h, 16);
    }

    lighten(color, weight) {
        return this.mix('FFFFFF', color, weight)
    }

    darken(color, weight) {
        return this.mix('000000', color, weight)
    }

    // mix two colors... to lighten mix white as the first color, to darken, mix black
    mix(color1, color2, weight) {
        weight = (typeof(weight) !== 'undefined') ? weight : 50; // set the weight to 50%, if that argument is omitted

        let color = "#";

        for(let i = 0; i <= 5; i += 2) { // loop through each of the 3 hex pairs—red, green, and blue
            let v1 = this.h2d(color1.substr(i, 2)), // extract the current pairs
                v2 = this.h2d(color2.substr(i, 2)),

                // combine the current pairs from each source color, according to the specified weight
                val = this.d2h(Math.floor(v2 + (v1 - v2) * (weight / 100.0)));

            while(val.length < 2) { val = '0' + val; } // prepend a '0' if val results in a single digit

            color += val; // concatenate val to our new color string
        }

        return color; // PROFIT!
    };

    isValidHexColor(hexValue) {
        if(hexValue && hexValue.length === 7 && hexValue.indexOf('#') === 0 ) {
            return true
        }

        return false
    }

    getFamilyColors(colorFamily) {
        let twColors = this.tailwindColors()
        return twColors[colorFamily]
    }

    getHexValue(colorName, colorShade) {
        let colorShades = this.getFamilyColors(colorName)

        if(!colorShade) {
            colorShade = 500
        }

        return colorShades[colorShade]
    }

    availableColors() {
        let twColors = this.tailwindColors()
        let colors = []
        let mainColors = Object.keys(twColors)
        let shades = Object.keys(twColors['slate'])

        for(let j = shades.length; j > 0 ; j-- ) {
            let shade = shades[j - 1]

            // if(j % 2 === 0 || j === 5) {
            // if(j !== 2 && j !== 4) {

                for(let i = 0; i < mainColors.length; i++ ) {
                    let colorLabel = mainColors[i]

                    if(colorLabel === 'black' || colorLabel === 'white') {
                        continue
                    }

                    let mainColor = twColors[colorLabel]
                    let shadeColor = mainColor[shade]

                    if(colorLabel === 'slate' && shade === '50') {
                        shadeColor = '#FFFFFF'
                    }
                    else if(colorLabel === 'slate' && shade === '90') {
                        shadeColor = '#000000'
                    }


                    colors.push(shadeColor)

                    ColorUtil.colorMap[shadeColor] = {
                        color: colorLabel,
                        shade: shade,
                        value: shadeColor
                    }
                }
            // }
        }

        return colors
    }

    originalAvailableColors() {
        return [
            '#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00',
            '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF',
            '#333333', '#808080', '#CCCCCC', '#D33115', '#E27300', '#FCC400',
            '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF',
            '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00',
            '#808900', '#018cff', '#0C797D', '#0062B1', '#653294', '#AB149E'
          ]
    }

    tailwindBrightColorsFromAssets() {
        return Object.keys(TailwindColorsAssets).filter((color) => {
            return color !== 'black' && color !== 'white' && color !== 'slate' && color !== 'transparent' &&
                color !== 'gray' && color !== 'zinc' && color !== 'neutral' && color !== 'stone'
        })
    }

    tailwindBrightColors() {
        return Object.keys(this.tailwindColors()).filter((color) => {
            return color !== 'black' && color !== 'white' && color !== 'slate' && color !== 'transparent' &&
                color !== 'gray' && color !== 'zinc' && color !== 'neutral' && color !== 'stone'
        })
    }

    tailwindNeutralColors() {
        return Object.keys(this.tailwindColors()).filter((color) => {
            return color === 'slate' || color === 'gray' || color === 'zinc' || color === 'neutral' || color === 'stone'
        })
    }

    tailwindColorNames() {
        return Object.keys(this.tailwindColors())
    }

    tailwindColors() {
        return {
            transparent: 'transparent',
            black: '#000',
            white: '#fff',
            slate: {
                50: '#f8fafc',
                100: '#f1f5f9',
                200: '#e2e8f0',
                300: '#cbd5e1',
                400: '#94a3b8',
                500: '#64748b',
                600: '#475569',
                700: '#334155',
                800: '#1e293b',
                900: '#0f172a',
            },
            gray: {
                50: '#f9fafb',
                100: '#f3f4f6',
                200: '#e5e7eb',
                300: '#d1d5db',
                400: '#9ca3af',
                500: '#6b7280',
                600: '#4b5563',
                700: '#374151',
                800: '#1f2937',
                900: '#111827',
            },
            zinc: {
                50: '#fafafa',
                100: '#f4f4f5',
                200: '#e4e4e7',
                300: '#d4d4d8',
                400: '#a1a1aa',
                500: '#71717a',
                600: '#52525b',
                700: '#3f3f46',
                800: '#27272a',
                900: '#18181b',
            },
            // neutral: {
            //     50: '#fafafa',
            //     100: '#f5f5f5',
            //     200: '#e5e5e5',
            //     300: '#d4d4d4',
            //     400: '#a3a3a3',
            //     500: '#737373',
            //     600: '#525252',
            //     700: '#404040',
            //     800: '#262626',
            //     900: '#171717',
            // },
            stone: {
                50: '#fafaf9',
                100: '#f5f5f4',
                200: '#e7e5e4',
                300: '#d6d3d1',
                400: '#a8a29e',
                500: '#78716c',
                600: '#57534e',
                700: '#44403c',
                800: '#292524',
                900: '#1c1917',
            },
            blue: {
                50: '#eff6ff',
                100: '#dbeafe',
                200: '#bfdbfe',
                300: '#93c5fd',
                400: '#60a5fa',
                500: '#3b82f6',
                600: '#2563eb',
                700: '#1d4ed8',
                800: '#1e40af',
                900: '#1e3a8a',
            },
            indigo: {
                50: '#eef2ff',
                100: '#e0e7ff',
                200: '#c7d2fe',
                300: '#a5b4fc',
                400: '#818cf8',
                500: '#6366f1',
                600: '#4f46e5',
                700: '#4338ca',
                800: '#3730a3',
                900: '#312e81',
            },
            violet: {
                50: '#f5f3ff',
                100: '#ede9fe',
                200: '#ddd6fe',
                300: '#c4b5fd',
                400: '#a78bfa',
                500: '#8b5cf6',
                600: '#7c3aed',
                700: '#6d28d9',
                800: '#5b21b6',
                900: '#4c1d95',
            },
            purple: {
                50: '#faf5ff',
                100: '#f3e8ff',
                200: '#e9d5ff',
                300: '#d8b4fe',
                400: '#c084fc',
                500: '#a855f7',
                600: '#9333ea',
                700: '#7e22ce',
                800: '#6b21a8',
                900: '#581c87',
            },
            fuchsia: {
                50: '#fdf4ff',
                100: '#fae8ff',
                200: '#f5d0fe',
                300: '#f0abfc',
                400: '#e879f9',
                500: '#d946ef',
                600: '#c026d3',
                700: '#a21caf',
                800: '#86198f',
                900: '#701a75',
            },
            pink: {
                50: '#fdf2f8',
                100: '#fce7f3',
                200: '#fbcfe8',
                300: '#f9a8d4',
                400: '#f472b6',
                500: '#ec4899',
                600: '#db2777',
                700: '#be185d',
                800: '#9d174d',
                900: '#831843',
            },
            rose: {
                50: '#fff1f2',
                100: '#ffe4e6',
                200: '#fecdd3',
                300: '#fda4af',
                400: '#fb7185',
                500: '#f43f5e',
                600: '#e11d48',
                700: '#be123c',
                800: '#9f1239',
                900: '#881337',
            },
            red: {
                50: '#fef2f2',
                100: '#fee2e2',
                200: '#fecaca',
                300: '#fca5a5',
                400: '#f87171',
                500: '#ef4444',
                600: '#dc2626',
                700: '#b91c1c',
                800: '#991b1b',
                900: '#7f1d1d',
            },
            orange: {
                50: '#fff7ed',
                100: '#ffedd5',
                200: '#fed7aa',
                300: '#fdba74',
                400: '#fb923c',
                500: '#f97316',
                600: '#ea580c',
                700: '#c2410c',
                800: '#9a3412',
                900: '#7c2d12',
            },
            amber: {
                50: '#fffbeb',
                100: '#fef3c7',
                200: '#fde68a',
                300: '#fcd34d',
                400: '#fbbf24',
                500: '#f59e0b',
                600: '#d97706',
                700: '#b45309',
                800: '#92400e',
                900: '#78350f',
            },
            yellow: {
                50: '#fefce8',
                100: '#fef9c3',
                200: '#fef08a',
                300: '#fde047',
                400: '#facc15',
                500: '#eab308',
                600: '#ca8a04',
                700: '#a16207',
                800: '#854d0e',
                900: '#713f12',
            },
            lime: {
                50: '#f7fee7',
                100: '#ecfccb',
                200: '#d9f99d',
                300: '#bef264',
                400: '#a3e635',
                500: '#84cc16',
                600: '#65a30d',
                700: '#4d7c0f',
                800: '#3f6212',
                900: '#365314',
            },
            green: {
                50: '#f0fdf4',
                100: '#dcfce7',
                200: '#bbf7d0',
                300: '#86efac',
                400: '#4ade80',
                500: '#22c55e',
                600: '#16a34a',
                700: '#15803d',
                800: '#166534',
                900: '#14532d',
            },
            emerald: {
                50: '#ecfdf5',
                100: '#d1fae5',
                200: '#a7f3d0',
                300: '#6ee7b7',
                400: '#34d399',
                500: '#10b981',
                600: '#059669',
                700: '#047857',
                800: '#065f46',
                900: '#064e3b',
            },
            teal: {
                50: '#f0fdfa',
                100: '#ccfbf1',
                200: '#99f6e4',
                300: '#5eead4',
                400: '#2dd4bf',
                500: '#14b8a6',
                600: '#0d9488',
                700: '#0f766e',
                800: '#115e59',
                900: '#134e4a',
            },
            cyan: {
                50: '#ecfeff',
                100: '#cffafe',
                200: '#a5f3fc',
                300: '#67e8f9',
                400: '#22d3ee',
                500: '#06b6d4',
                600: '#0891b2',
                700: '#0e7490',
                800: '#155e75',
                900: '#164e63',
            },
            sky: {
                50: '#f0f9ff',
                100: '#e0f2fe',
                200: '#bae6fd',
                300: '#7dd3fc',
                400: '#38bdf8',
                500: '#0ea5e9',
                600: '#0284c7',
                700: '#0369a1',
                800: '#075985',
                900: '#0c4a6e',
            }
        }
    }
}